<template>
  <div class="main_loading">
    <img class="main_loading__icon" src="static/images/main_loading.gif" width="120px" />
  </div>
</template>

<script>
export default {
  name: 'MainLoading'
};
</script>

<style lang="scss">
  .main_loading {
    text-align: center;
    .main_loading__icon {
      margin: 5px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/MainLoading.vue